/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Activity_Bar_Processing_OtherInputs */



/**
* | output |
* | --- |
* | "{count} items processing..." |
*
* @param {Activity_Bar_Processing_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_bar_processing_other = /** @type {((inputs: Activity_Bar_Processing_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Bar_Processing_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Elemente werden verarbeitet...`)
	return /** @type {LocalizedString} */ (`${i?.count} items processing...`)
});